var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';

import Login from './Login';
import LoginHeader from './LoginHeader';
import LoginHeaderBrand from './LoginHeaderBrand';
import LoginFooter from './LoginFooter';

import LoginBox from './LoginBox';
import LoginBoxHeader from './LoginBoxHeader';
import LoginBoxBody from './LoginBoxBody';
import LoginBoxFooter from './LoginBoxFooter';

import { BackgroundImage } from '../BackgroundImage';
import { Brand } from '../Brand';
import { Text, TextContent } from '../Text';
import { List } from '../List';

var LoginListVariant = {
  grid: 'grid',
  inline: 'inline'
};

var propTypes = {
  /** Anything that can be rendered inside of the LoginPage */
  children: PropTypes.node,
  /** Additional classes added to the LoginPage. */
  className: PropTypes.string,
  /** Attribute that specifies the URL of the brand image for the LoginPage */
  mainBrandImgSrc: PropTypes.string,
  /** Attribute that specifies the alt text of the brand image for the LoginPage. */
  mainBrandImgAlt: PropTypes.string,
  /** Attribute that specifies the URL of the background image for the LoginPage */
  mainBackgroundImgSrc: PropTypes.string,
  /** Attribute that specifies the alt text of the background image for the LoginPage. */
  mainBackgroundImgAlt: PropTypes.string,
  /** Content rendered inside of the Text Component of the LoginPage */
  mainTextContent: PropTypes.string,
  /** Items rendered inside of the List Component of the LoginPage */
  mainListItems: PropTypes.node,
  /** Adds list variant styles for the List component of the LoginPage */
  mainListVariants: PropTypes.oneOf(Object.values(LoginListVariant)),
  /** Language dropdown component for the LoginBox Header of the LoginPage */
  loginLanguageDropdown: PropTypes.node,
  /** Title for the LoginBox Header of the LoginPage */
  loginTitle: PropTypes.string.isRequired,
  /** Login subtitle that contains the Text, URL, and URL Text for the LoginBox Header of the LoginPage */
  loginSubtitle: PropTypes.node,
  /** Content rendered inside of the LoginBox Footer of the LoginPage */
  loginFooterContent: PropTypes.node
};

var defaultProps = {
  children: null,
  className: '',
  mainBrandImgSrc: '',
  mainBrandImgAlt: '',
  mainBackgroundImgSrc: '',
  mainBackgroundImgAlt: '',
  mainListItems: null,
  mainTextContent: '',
  mainListVariants: null,
  loginLanguageDropdown: null,
  loginSubtitle: null,
  loginFooterContent: null
};

var LoginPage = function LoginPage(_ref) {
  var className = _ref.className,
      children = _ref.children,
      mainBrandImgSrc = _ref.mainBrandImgSrc,
      mainBrandImgAlt = _ref.mainBrandImgAlt,
      mainBackgroundImgSrc = _ref.mainBackgroundImgSrc,
      mainBackgroundImgAlt = _ref.mainBackgroundImgAlt,
      mainTextContent = _ref.mainTextContent,
      mainListItems = _ref.mainListItems,
      mainListVariants = _ref.mainListVariants,
      loginLanguageDropdown = _ref.loginLanguageDropdown,
      loginTitle = _ref.loginTitle,
      loginSubtitle = _ref.loginSubtitle,
      loginFooterContent = _ref.loginFooterContent,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'mainBrandImgSrc', 'mainBrandImgAlt', 'mainBackgroundImgSrc', 'mainBackgroundImgAlt', 'mainTextContent', 'mainListItems', 'mainListVariants', 'loginLanguageDropdown', 'loginTitle', 'loginSubtitle', 'loginFooterContent']);

  var HeaderBrand = React.createElement(
    React.Fragment,
    null,
    React.createElement(
      LoginHeaderBrand,
      null,
      React.createElement(Brand, { src: mainBrandImgSrc, alt: mainBrandImgAlt })
    ),
    React.createElement(
      TextContent,
      null,
      React.createElement(
        Text,
        null,
        mainTextContent
      )
    )
  );
  var Header = React.createElement(LoginHeader, { headerBrand: HeaderBrand });
  var Footer = React.createElement(
    LoginFooter,
    null,
    React.createElement(
      List,
      { variant: mainListVariants },
      mainListItems
    )
  );

  return React.createElement(
    React.Fragment,
    null,
    mainBackgroundImgSrc && React.createElement(BackgroundImage, { src: mainBackgroundImgSrc, alt: mainBackgroundImgAlt }),
    React.createElement(
      Login,
      _extends({ header: Header, footer: Footer }, props, { className: css(className) }),
      React.createElement(
        LoginBox,
        null,
        React.createElement(LoginBoxHeader, { title: loginTitle, dropdown: loginLanguageDropdown, subtitle: loginSubtitle }),
        React.createElement(
          LoginBoxBody,
          null,
          children
        ),
        loginFooterContent && React.createElement(
          LoginBoxFooter,
          null,
          loginFooterContent
        )
      )
    )
  );
};

LoginPage.propTypes = propTypes;
LoginPage.defaultProps = defaultProps;

export default LoginPage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/LoginPage/LoginPage.js
// module id = 249
// module chunks = 0